import { render, staticRenderFns } from "./cooperativeList.vue?vue&type=template&id=385a9049&scoped=true&"
import script from "./cooperativeList.vue?vue&type=script&lang=js&"
export * from "./cooperativeList.vue?vue&type=script&lang=js&"
import style0 from "./cooperativeList.vue?vue&type=style&index=0&id=385a9049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a9049",
  null
  
)

export default component.exports